// InventoryHelper.js - 背包工具类
// 统一 EquipmentSystem 和 ItemSystem 中的 removeFromInventory 方法

export default class InventoryHelper {
    /**
     * 从背包中移除道具
     * @param {Object} item - 道具对象
     * @param {Array} inventory - 背包数组
     * @returns {boolean} 是否移除成功
     */
    static removeFromInventory(item, inventory) {
        if (!item || !inventory) return false;
        
        const index = inventory.findIndex(invItem => {
            // 通过ID匹配
            if (item.id && invItem.id) {
                return invItem.id === item.id;
            }
            // 通过名称匹配
            if (item.name && invItem.name) {
                return invItem.name === item.name;
            }
            return false;
        });
        
        if (index !== -1) {
            inventory.splice(index, 1);
            return true;
        }
        
        return false;
    }
    
    /**
     * 添加道具到背包
     * @param {Object} item - 道具对象
     * @param {Array} inventory - 背包数组
     * @returns {boolean} 是否添加成功
     */
    static addToInventory(item, inventory) {
        if (!item || !inventory) return false;
        
        // 检查背包是否已满（可以添加容量限制）
        inventory.push(item);
        return true;
    }
    
    /**
     * 检查背包中是否有指定道具
     * @param {Object} item - 道具对象
     * @param {Array} inventory - 背包数组
     * @returns {boolean} 是否存在
     */
    static hasItem(item, inventory) {
        if (!item || !inventory) return false;
        
        return inventory.some(invItem => {
            if (item.id && invItem.id) {
                return invItem.id === item.id;
            }
            if (item.name && invItem.name) {
                return invItem.name === item.name;
            }
            return false;
        });
    }
    
    /**
     * 获取背包中指定道具的数量
     * @param {Object} item - 道具对象
     * @param {Array} inventory - 背包数组
     * @returns {number} 道具数量
     */
    static getItemCount(item, inventory) {
        if (!item || !inventory) return 0;
        
        return inventory.filter(invItem => {
            if (item.id && invItem.id) {
                return invItem.id === item.id;
            }
            if (item.name && invItem.name) {
                return invItem.name === item.name;
            }
            return false;
        }).length;
    }
}

